/* eslint-disable max-lines */
export const APPLY = 'APPLY';
export const BRANDS = 'BRANDS';
export const CLEAR_ALL = 'CLEAR_ALL';
export const FILTER = 'FILTER';
export const FILTERS = 'FILTERS';
export const NO_FILTER_APPLIED = 'NO_FILTER_APPLIED';
export const CATEGORIES = 'CATEGORIES';
export const LOG_IN = 'LOG_IN';
export const NOTIFY_ME = 'NOTIFY_ME';
export const VIEW_SHADES = 'VIEW_SHADES';
export const VIEW_SIZES = 'VIEW_SIZES';
export const SORT_BY = 'SORT_BY';
export const ADD_TO_BAG = 'ADD_TO_BAG';
export const GO_TO_BAG = 'GO_TO_BAG';
export const DYNAMIC_COMPLETE_COLLECTION = 'DYNAMIC_COMPLETE_COLLECTION';
export const VIEW_BAG = 'VIEW_BAG';
export const CHANGE = 'CHANGE';
export const READ_LESS = 'READ_LESS';
export const READ_MORE = 'READ_MORE';
export const READ_ALL_REVIEWS = 'READ_ALL_REVIEWS';
export const NO_MORE_PRODUCTS_TO_SHOW = 'NO_MORE_PRODUCTS_TO_SHOW';
export const VIEW_PRODUCTS = 'VIEW_PRODUCTS';
export const RATE = 'RATE';
export const RATE_PRODUCT = 'RATE_PRODUCT';
export const SHARE = 'SHARE';
export const WRITE_A_REVIEW = 'WRITE_A_REVIEW';
export const ADDING = 'ADDING';
export const CHECK = 'CHECK';
export const PHOTOS_FROM_CUSTOMERS = 'PHOTOS_FROM_CUSTOMERS';
export const REGISTER = 'REGISTER';
export const MOST_USEFUL_REVIEW = 'MOST_USEFUL_REVIEW';
export const ADDED_TO_CART = 'ADDED_TO_CART';
export const SPECIAL_COUPONS = 'SPECIAL_COUPONS';
export const NO_MORE_REVIEWS_TO_SHOW = 'NO_MORE_REVIEWS_TO_SHOW';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const GET_EXTRA_DISCOUNTS = 'GET_EXTRA_DISCOUNTS';
export const WRITE_NEW = 'WRITE_NEW';
export const GET_SPECIAL_DISCOUNT = 'GET_SPECIAL_DISCOUNT';
export const FEW_LEFT = 'FEW_LEFT';
export const NOTIFY_STOCK = 'NOTIFY_STOCK';
export const YOUR_EMAIL = 'YOUR_EMAIL';
export const HOW_TO_USE = 'HOW_TO_USE';
export const OVERALL_RATING = 'OVERALL_RATING';
export const SHARE_ERROR = 'SHARE_ERROR';
export const SHARE_COPIED = 'SHARE_COPIED';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const REVIEWS_NOT_FOUND = 'REVIEWS_NOT_FOUND';
export const NO_REVIEWS_WRITTEN = 'NO_REVIEWS_WRITTEN';
export const NO_REVIEWS_ON_PRODUCT = 'NO_REVIEWS_ON_PRODUCT';
export const SORT_REVIEWS = 'SORT_REVIEWS';
export const SELECT_SHADE = 'SELECT_SHADE';
export const SELECT_SIZE = 'SELECT_SIZE';
export const SHADE = 'SHADE';
export const SIZE = 'SIZE';
export const SOLD_OUT = 'SOLD_OUT';
export const LOAD_MORE = 'LOAD_MORE';
export const NEED_HELP = 'NEED_HELP';
export const GIFT_CARDS = 'GIFT_CARDS';
export const NYKAA_CSR = 'NYKAA_CSR';
export const RESPONSIBLE_DISCLOSURE = 'RESPONSIBLE_DISCLOSURE';
export const MY_ORDERS = 'MY_ORDERS';
export const MY_WALLET = 'MY_WALLET';
export const NYKAA_PRIVE = 'NYKAA_PRIVE';
export const NYKAA_SUBSCRIPTION = 'NYKAA_SUBSCRIPTION';
export const BEAUTY_PORTFOLIO = 'BEAUTY_PORTFOLIO';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_ALL_TEXT = 'LOGOUT_ALL_TEXT';
export const LOGOUT_CONFIRM = 'LOGOUT_CONFIRM';
export const MY_PROFILE = 'MY_PROFILE';
export const CODE_COPIED = 'CODE_COPIED';
export const MY_WISHLIST = 'MY_WISHLIST';
export const AUTHENTICITY = 'AUTHENTICITY';
export const VIDEO_CONSULTATION = 'VIDEO_CONSULTATION';
export const HELP_CENTER = 'HELP_CENTER';
export const SEARCH_PLACEHOLDER = 'SEARCH_PLACEHOLDER';
export const REVIEWS = 'REVIEWS';
export const RATINGS = 'RATINGS';
export const WE_RECOMMEND_YOU = 'WE_RECOMMEND_YOU';
export const LANG_SELECTOR_TOOLTIP_TITLE = 'LANG_SELECTOR_TOOLTIP_TITLE';
export const LANG_SELECTOR_TOOLTIP_MESSAGE = 'LANG_SELECTOR_TOOLTIP_MESSAGE';
export const LANG_SELECTOR_TOOLTIP_CONFIRMATION =
  'LANG_SELECTOR_TOOLTIP_CONFIRMATION';
export const DELIVERY_DETAILS_NOT_FOUND = 'DELIVERY_DETAILS_NOT_FOUND';
export const FETCHING_DELIVERY_DETAILS = 'FETCHING_DELIVERY_DETAILS';
export const DYNAMIC_APPLIED = 'DYNAMIC_APPLIED';
export const DYNAMIC_LEFT = 'DYNAMIC_LEFT';
export const DYNAMIC_SIZES = 'DYNAMIC_SIZES';
export const DYNAMIC_SHADES = 'DYNAMIC_SHADES';
export const SHARE_GREETING = 'SHARE_GREETING';
export const DYNAMIC_PRODUCTS = 'DYNAMIC_PRODUCTS';
export const DYNAMIC_RESULTS = 'DYNAMIC_RESULTS';
export const DYNAMIC_SHIPPING = 'DYNAMIC_SHIPPING';
export const DYNAMIC_DELIVERY_EST = 'DYNAMIC_DELIVERY_EST';
export const DYNAMIC_FREE_SHIPPING = 'DYNAMIC_FREE_SHIPPING';
export const DYNAMIC_VERIFIED_RATING = 'DYNAMIC_VERIFIED_RATING';
export const DYNAMIC_DELIVERY_DETAILS = 'DYNAMIC_DELIVERY_DETAILS';
export const DYNAMIC_PERCENTAGE_OFF = 'DYNAMIC_PERCENTAGE_OFF';
export const DYNAMIC_BASED_ON_REVIEWS_RATINGS =
  'DYNAMIC_BASED_ON_REVIEWS_RATINGS';
export const DISCOUNT_OFF_EXCLAMATION = 'DISCOUNT_OFF_EXCLAMATION';
export const DISCOUNT_PERCENT_OFF = 'DISCOUNT_PERCENT_OFF';
export const SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS';
export const VIEW_SIMILAR_PRODUCTS = 'VIEW_SIMILAR_PRODUCTS';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADDED_TO_WISHLIST = 'ADDED_TO_WISHLIST';
export const VIEW_ALL_PRODUCTS = 'VIEW_ALL_PRODUCTS';
export const PLP = 'PLP';
export const RECO_PRODUCTS = 'RECO_PRODUCTS';
export const DISCARD_CHANGES = 'DISCARD_CHANGES';
export const DISCARD_CHANGES_SUBTITLE = 'DISCARD_CHANGES_SUBTITLE';
export const DISCARD = 'DISCARD';
export const ONLY_TAGS = 'ONLY_TAGS';
export const TAGS_AND_RATING = 'TAGS_AND_RATING';
export const ONLY_RATINGS = 'ONLY_RATINGS';
export const SUSTAINABILITY = 'SUSTAINABILITY';

export const META_ALL_REVIEWS_PAGE_DESCRIPTION =
  'META_ALL_REVIEWS_PAGE_DESCRIPTION';
export const META_ALL_REVIEWS_PAGE_TITLE = 'META_ALL_REVIEWS_PAGE_TITLE';
export const META_BRAND_PAGE_DESCRIPTION = 'META_BRAND_PAGE_DESCRIPTION';
export const META_BRAND_PAGE_TITLE = 'META_BRAND_PAGE_TITLE';
export const META_COUPON_OFFERS_DESCRIPTION = 'META_COUPON_OFFERS_DESCRIPTION';
export const META_COUPON_OFFERS_TITLE = 'META_COUPON_OFFERS_TITLE';
export const META_PRODUCT_PAGE_DESCRIPTION = 'META_PRODUCT_PAGE_DESCRIPTION';
export const META_PRODUCT_PAGE_TITLE = 'META_PRODUCT_PAGE_TITLE';
export const META_SEARCH_PAGE_DESCRIPTION = 'META_SEARCH_PAGE_DESCRIPTION';
export const META_SEARCH_PAGE_KEYWORDS = 'META_SEARCH_PAGE_KEYWORDS';
export const META_SEARCH_PAGE_TITLE = 'META_SEARCH_PAGE_TITLE';
export const FOOTER_APP_LINKS_TITLE = 'FOOTER_APP_LINKS_TITLE';
export const FOOTER_FEATURES_BRANDS_COUNT_TEXT =
  'FOOTER_FEATURES_BRANDS_COUNT_TEXT';
export const FOOTER_FEATURES_BRANDS_COUNT_TITLE =
  'FOOTER_FEATURES_BRANDS_COUNT_TITLE';
export const FOOTER_FEATURES_EASY_RETURNS_TEXT =
  'FOOTER_FEATURES_EASY_RETURNS_TEXT';
export const FOOTER_FEATURES_EASY_RETURNS_TITLE =
  'FOOTER_FEATURES_EASY_RETURNS_TITLE';
export const FOOTER_FEATURES_FREE_SHIP_TEXT = 'FOOTER_FEATURES_FREE_SHIP_TEXT';
export const FOOTER_FEATURES_FREE_SHIP_TITLE =
  'FOOTER_FEATURES_FREE_SHIP_TITLE';
export const FOOTER_FEATURES_GENUINE_PRODUCT_TEXT =
  'FOOTER_FEATURES_GENUINE_PRODUCT_TEXT';
export const FOOTER_FEATURES_GENUINE_PRODUCT_TITLE =
  'FOOTER_FEATURES_GENUINE_PRODUCT_TITLE';
export const FOOTER_SOCIAL_LINKS_TEXT = 'FOOTER_SOCIAL_LINKS_TEXT';
export const APP_INSTALL_NUDGE_CONFIG_CTA_LABEL =
  'APP_INSTALL_NUDGE_CONFIG_CTA_LABEL';
export const APP_INSTALL_NUDGE_CONFIG_SUB_TITLE =
  'APP_INSTALL_NUDGE_CONFIG_SUB_TITLE';
export const APP_INSTALL_NUDGE_CONFIG_TITLE = 'APP_INSTALL_NUDGE_CONFIG_TITLE';
export const COLLAPSE_PD_CONFIG_COUPON_SECTION_TITLE =
  'COLLAPSE_PD_CONFIG_COUPON_SECTION_TITLE';
export const COLLAPSE_PD_CONFIG_DELIVERY_SECTION_TITLE =
  'COLLAPSE_PD_CONFIG_DELIVERY_SECTION_TITLE';
export const COLLAPSE_PD_CONFIG_RETURN_SECTION_TITLE =
  'COLLAPSE_PD_CONFIG_RETURN_SECTION_TITLE';
export const COLLAPSE_PD_CONFIG_RNR_SECTION_SUB_TITLE =
  'COLLAPSE_PD_CONFIG_RNR_SECTION_SUB_TITLE';
export const UPI_OFFER_MESSAGE = 'UPI_OFFER_MESSAGE';
export const LISTING_PRICE_REVEAL_ADDED_TO_BOX_TOAST_MESSAGE =
  'LISTING_PRICE_REVEAL_ADDED_TO_BOX_TOAST_MESSAGE';
export const LISTING_PRICE_REVEAL_ALREADY_ADDED_MEESAGE =
  'LISTING_PRICE_REVEAL_ALREADY_ADDED_MEESAGE';
export const LISTING_PRICE_REVEAL_SECONDARY_ACTION_LABEL =
  'LISTING_PRICE_REVEAL_SECONDARY_ACTION_LABEL';
export const LISTING_PRICE_REVEAL_TITLE = 'LISTING_PRICE_REVEAL_TITLE';
export const PD_PRICE_REVEAL_ADDED_TO_BOX_ERROR_MESSAGE =
  'PD_PRICE_REVEAL_ADDED_TO_BOX_ERROR_MESSAGE';
export const PD_PRICE_REVEAL_PRIMARY_ACTION_LABEL =
  'PD_PRICE_REVEAL_PRIMARY_ACTION_LABEL';
export const PD_PRICE_REVEAL_SECONDARY_ACTION_LABEL =
  'PD_PRICE_REVEAL_SECONDARY_ACTION_LABEL';
export const PD_PRICE_REVEAL_TITLE = 'PD_PRICE_REVEAL_TITLE';
export const PLP_PRICE_REVEAL_TEXT = 'PLP_PRICE_REVEAL_TEXT';
export const PRICE_REVEAL_DATA_ALREADY_ADDED_TO_BOX_INFO =
  'PRICE_REVEAL_DATA_ALREADY_ADDED_TO_BOX_INFO';
export const PRICE_REVEAL_DATA_BUCKET_TITLE = 'PRICE_REVEAL_DATA_BUCKET_TITLE';
export const PRICE_REVEAL_DATA_SALE_OFFER_TITLE =
  'PRICE_REVEAL_DATA_SALE_OFFER_TITLE';
export const PRICE_REVEAL_DATA_SEO_DATA_META_DESCRIPTION =
  'PRICE_REVEAL_DATA_SEO_DATA_META_DESCRIPTION';
export const PRICE_REVEAL_DATA_SEO_DATA_META_TITLE =
  'PRICE_REVEAL_DATA_SEO_DATA_META_TITLE';
export const PRICE_REVEAL_DATA_SHARE_MESSAGE =
  'PRICE_REVEAL_DATA_SHARE_MESSAGE';
export const PRICE_REVEAL_DATA_SHARE_TITLE = 'PRICE_REVEAL_DATA_SHARE_TITLE';
export const BUY_NOW_PAY_LATER_CONFIG_PDP_PAGE_TEXT =
  'BUY_NOW_PAY_LATER_CONFIG_PDP_PAGE_TEXT';
export const BUY_NOW_PAY_LATER_CONFIG_TITLE = 'BUY_NOW_PAY_LATER_CONFIG_TITLE';
export const AB_PERSONAL_COUPONS_DEFAULT_DESC =
  'AB_PERSONAL_COUPONS_DEFAULT_DESC';
export const AB_SHIPPING_STRIP_CONFIGS_CODMSG =
  'AB_SHIPPING_STRIP_CONFIGS_CODMSG';
export const AB_SHIPPING_STRIP_CONFIGS_FREE_SHIPPING_COD =
  'AB_SHIPPING_STRIP_CONFIGS_FREE_SHIPPING_COD';
export const AB_SHIPPING_STRIP_CONFIGS_FREE_SHIPPING_MSG =
  'AB_SHIPPING_STRIP_CONFIGS_FREE_SHIPPING_MSG';
export const AF_DOWNLOAD_STRIP_CONFIG_CTA_TEXT =
  'AF_DOWNLOAD_STRIP_CONFIG_CTA_TEXT';
export const AF_DOWNLOAD_STRIP_CONFIG_TITLE = 'AF_DOWNLOAD_STRIP_CONFIG_TITLE';
export const HOMEH1TAG = 'HOMEH1TAG';
export const KNOW_MORE_CONFIG_PRIMARY_TEXT = 'KNOW_MORE_CONFIG_PRIMARY_TEXT';
export const KNOW_MORE_CONFIG_SUB_TITLE = 'KNOW_MORE_CONFIG_SUB_TITLE';
export const KNOW_MORE_CONFIG_TITLE = 'KNOW_MORE_CONFIG_TITLE';
export const NO_SEARCH_PAGE_PAGE_NOT_FOUND_TITLE =
  'NO_SEARCH_PAGE_PAGE_NOT_FOUND_TITLE';
export const NO_SEARCH_PAGE_REDIRECT_TEXT = 'NO_SEARCH_PAGE_REDIRECT_TEXT';
export const NO_SEARCH_PAGE_SUBTITLE = 'NO_SEARCH_PAGE_SUBTITLE';
export const NO_SEARCH_PAGE_TITLE = 'NO_SEARCH_PAGE_TITLE';
export const PNW_SHARE_TEXT = 'PNW_SHARE_TEXT';
export const PNW_SHARE_TITLE = 'PNW_SHARE_TITLE';
export const PRO_WARNING_TEXT = 'PRO_WARNING_TEXT';
export const PRODUCT_ATTR_CATEGORIES_TITLE = 'PRODUCT_ATTR_CATEGORIES_TITLE';
export const PRODUCTS_COUNT = 'PRODUCTS_COUNT';
export const RELEVANT_CATEGORIES_PDP_TITLE = 'RELEVANT_CATEGORIES_PDP_TITLE';
export const SEARCH_BOX_RECENTLY_VIEWED_WIDGET =
  'SEARCH_BOX_RECENTLY_VIEWED_WIDGET';
export const SEE_MORE = 'SEE_MORE';
export const STORE_OPTIONS_BACK_TO_BEAUTY_TEXT =
  'STORE_OPTIONS_BACK_TO_BEAUTY_TEXT';
export const BUY_NOW_PAY_LATER_APPROVAL_IS_SUBJECT_ELIGIBILITY =
  'BUY_NOW_PAY_LATER_APPROVAL_IS_SUBJECT_ELIGIBILITY';
export const BUY_NOW_PAY_LATER_BUYER_PROTECTION_IS_INCLUDED =
  'BUY_NOW_PAY_LATER_BUYER_PROTECTION_IS_INCLUDED';
export const BUY_NOW_PAY_LATER_CHOOSE_TABBY_CHECKOUT_SELECT =
  'BUY_NOW_PAY_LATER_CHOOSE_TABBY_CHECKOUT_SELECT';
export const BUY_NOW_PAY_LATER_CHOOSE_TAMARA_CHECKOUT_SELECT =
  'BUY_NOW_PAY_LATER_CHOOSE_TAMARA_CHECKOUT_SELECT';
export const BUY_NOW_PAY_LATER_ENTER_YOUR_CARD_DETAILS =
  'BUY_NOW_PAY_LATER_ENTER_YOUR_CARD_DETAILS';
export const BUY_NOW_PAY_LATER_ENTER_YOUR_INFORMATION_ADD =
  'BUY_NOW_PAY_LATER_ENTER_YOUR_INFORMATION_ADD';
export const BUY_NOW_PAY_LATER_GET_HELPFUL_REMINDERS_BEFORE =
  'BUY_NOW_PAY_LATER_GET_HELPFUL_REMINDERS_BEFORE';
export const BUY_NOW_PAY_LATER_OVER_10_MILLION_SHOPPERS =
  'BUY_NOW_PAY_LATER_OVER_10_MILLION_SHOPPERS';
export const BUY_NOW_PAY_LATER_PAYMENT_PLANS_SHOWN_ARE =
  'BUY_NOW_PAY_LATER_PAYMENT_PLANS_SHOWN_ARE';
export const BUY_NOW_PAY_LATER_SHOP_SAFELY_WITH_TABBY =
  'BUY_NOW_PAY_LATER_SHOP_SAFELY_WITH_TABBY';
export const BUY_NOW_PAY_LATER_TABBY = 'BUY_NOW_PAY_LATER_TABBY';
export const BUY_NOW_PAY_LATER_TAMARA = 'BUY_NOW_PAY_LATER_TAMARA';
export const BUY_NOW_PAY_LATER_TRACK_MANAGE_ALL_OUR =
  'BUY_NOW_PAY_LATER_TRACK_MANAGE_ALL_OUR';
export const BUY_NOW_PAY_LATER_TRUSTED_BY_MILLIONS =
  'BUY_NOW_PAY_LATER_TRUSTED_BY_MILLIONS';
export const BUY_NOW_PAY_LATER_WE_LL_SEND_YOU =
  'BUY_NOW_PAY_LATER_WE_LL_SEND_YOU';
export const BUY_NOW_PAY_LATER_YOUR_FIRST_PAYMENT_IS =
  'BUY_NOW_PAY_LATER_YOUR_FIRST_PAYMENT_IS';
export const COUPON_ALL_ORDERS_ABOVE_1500 = 'COUPON_ALL_ORDERS_ABOVE_1500';
export const COUPON_APPLICABLE_ONLY_1ST_NYKAA =
  'COUPON_APPLICABLE_ONLY_1ST_NYKAA';
export const COUPON_APPLICABLE_ONLY_1ST_NYKAA_2 =
  'COUPON_APPLICABLE_ONLY_1ST_NYKAA_2';
export const COUPON_APPLICABLE_ONLY_1ST_NYKAA_3 =
  'COUPON_APPLICABLE_ONLY_1ST_NYKAA_3';
export const COUPON_EXTRA_10_OFF_APP = 'COUPON_EXTRA_10_OFF_APP';
export const COUPON_EXTRA_10_OFF_WEB = 'COUPON_EXTRA_10_OFF_WEB';
export const COUPON_EXTRA_20_OFF_APP = 'COUPON_EXTRA_20_OFF_APP';
export const COUPON_FLAT_400_OFF_APP = 'COUPON_FLAT_400_OFF_APP';
export const COUPON_YOUR_1ST_ORDER_NYKAA = 'COUPON_YOUR_1ST_ORDER_NYKAA';
export const COUPON_YOUR_1ST_ORDER_NYKAA_2 = 'COUPON_YOUR_1ST_ORDER_NYKAA_2';
export const SIGN_IN_TO_VIEW_MORE_COUPONS = 'SIGN_IN_TO_VIEW_MORE_COUPONS';
export const FOOTER_ACCOUNT_ABOUT_NYSAA = 'FOOTER_ACCOUNT_ABOUT_NYSAA';
export const FOOTER_ACCOUNT_PRIVACY = 'FOOTER_ACCOUNT_PRIVACY';
export const FOOTER_ACCOUNT_TERMS_CONDITIONS =
  'FOOTER_ACCOUNT_TERMS_CONDITIONS';
export const FOOTER_MENU_HELP_CANCELLATION_RETURN =
  'FOOTER_MENU_HELP_CANCELLATION_RETURN';
export const FOOTER_MENU_HELP_FREQUENTLY_ASKED_QUESTIONS =
  'FOOTER_MENU_HELP_FREQUENTLY_ASKED_QUESTIONS';
export const FOOTER_MENU_HELP_SHIPPING_DELIVERY =
  'FOOTER_MENU_HELP_SHIPPING_DELIVERY';
export const FOOTER_MENU_NYKAA_WHO_ARE_WE = 'FOOTER_MENU_NYKAA_WHO_ARE_WE';
export const FOOTER_MENU_QUICK_SITEMAP = 'FOOTER_MENU_QUICK_SITEMAP';
export const FOOTER_MENU_TOP_BATH_BODY = 'FOOTER_MENU_TOP_BATH_BODY';
export const FOOTER_MENU_TOP_FRAGRANCE = 'FOOTER_MENU_TOP_FRAGRANCE';
export const FOOTER_MENU_TOP_MAKEUP = 'FOOTER_MENU_TOP_MAKEUP';
export const FOOTER_POLICIES_CANCELLATION_POLICY =
  'FOOTER_POLICIES_CANCELLATION_POLICY';
export const FOOTER_POLICIES_PRIVACY_POLICY = 'FOOTER_POLICIES_PRIVACY_POLICY';
export const FOOTER_POLICIES_SHIPPING_POLICY =
  'FOOTER_POLICIES_SHIPPING_POLICY';
export const FOOTER_SOCIAL_FACEBOOK = 'FOOTER_SOCIAL_FACEBOOK';
export const FOOTER_SOCIAL_INSTAGRAM = 'FOOTER_SOCIAL_INSTAGRAM';
export const FOOTER_SOCIAL_TIKTOK = 'FOOTER_SOCIAL_TIKTOK';
export const FOOTER_SOCIAL_YOUTUBE = 'FOOTER_SOCIAL_YOUTUBE';
export const HLP_UTM_GOOGLEPAID = 'GooglePaid';
export const HTML = '.html';
export const KNOW_MORE_AS_SOON_AS_SALE = 'KNOW_MORE_AS_SOON_AS_SALE';
export const KNOW_MORE_SIMPLY_CHECKOUT_PAY_WHEN =
  'KNOW_MORE_SIMPLY_CHECKOUT_PAY_WHEN';
export const KNOW_MORE_TAP_ADD_PINK_BOX = 'KNOW_MORE_TAP_ADD_PINK_BOX';
export const PNW_FAQ_CONTEST_WILL_COMMENCE_FROM =
  'PNW_FAQ_CONTEST_WILL_COMMENCE_FROM';
export const PNW_FAQ_EVENT_PREDICTION_IS_CORRECT =
  'PNW_FAQ_EVENT_PREDICTION_IS_CORRECT';
export const PNW_FAQ_PREDICTION_WINDOW_MATCH_WILL =
  'PNW_FAQ_PREDICTION_WINDOW_MATCH_WILL';
export const PNW_FAQ_RESULTS_PREDICTION_WILL_REFLECT =
  'PNW_FAQ_RESULTS_PREDICTION_WILL_REFLECT';
export const PNW_FAQ_WHAT_IS_CONTEST_DURATION =
  'PNW_FAQ_WHAT_IS_CONTEST_DURATION';
export const PNW_FAQ_WHAT_IS_REWARD_IF = 'PNW_FAQ_WHAT_IS_REWARD_IF';
export const PNW_FAQ_WHEN_DOES_PREDICTION_WINDOW =
  'PNW_FAQ_WHEN_DOES_PREDICTION_WINDOW';
export const PNW_FAQ_WHEN_WILL_RESULTS_PREDICTION =
  'PNW_FAQ_WHEN_WILL_RESULTS_PREDICTION';
export const PNW_FAQ_WHO_CAN_PLAY_PREDICT = 'PNW_FAQ_WHO_CAN_PLAY_PREDICT';
export const PRIVE_FAQ_HOW_DO_I_BECOME = 'PRIVE_FAQ_HOW_DO_I_BECOME';
export const PRIVE_FAQ_HOW_DO_I_MOVE = 'PRIVE_FAQ_HOW_DO_I_MOVE';
export const PRIVE_FAQ_JOIN_OUR_NYKAA_PRIVE = 'PRIVE_FAQ_JOIN_OUR_NYKAA_PRIVE';
export const PRIVE_FAQ_NYKAA_PRIVE_PROGRAM_IS =
  'PRIVE_FAQ_NYKAA_PRIVE_PROGRAM_IS';
export const PRIVE_FAQ_WHAT_IS_NYKAA_PRIVE = 'PRIVE_FAQ_WHAT_IS_NYKAA_PRIVE';
export const PRIVE_FAQ_YOU_ONLY_NEED_KEEP = 'PRIVE_FAQ_YOU_ONLY_NEED_KEEP';
export const RELEVANT_CATEGORY_CONCEALER = 'RELEVANT_CATEGORY_CONCEALER';
export const RELEVANT_CATEGORY_EYE_LINER = 'RELEVANT_CATEGORY_EYE_LINER';
export const RELEVANT_CATEGORY_EYE_SHADOW = 'RELEVANT_CATEGORY_EYE_SHADOW';
export const RELEVANT_CATEGORY_FACE_PRIMER = 'RELEVANT_CATEGORY_FACE_PRIMER';
export const RELEVANT_CATEGORY_FOUNDATION = 'RELEVANT_CATEGORY_FOUNDATION';
export const RELEVANT_CATEGORY_HIGHLIGHTERS = 'RELEVANT_CATEGORY_HIGHLIGHTERS';
export const RELEVANT_CATEGORY_LIPSTICK = 'RELEVANT_CATEGORY_LIPSTICK';
export const RELEVANT_CATEGORY_LIQUID_LIPSTICK =
  'RELEVANT_CATEGORY_LIQUID_LIPSTICK';
export const SEARCH_TEXT_BEAUTY_PRODUCTS = 'SEARCH_TEXT_BEAUTY_PRODUCTS';
export const SEARCH_TEXT_CLEANSERS = 'SEARCH_TEXT_CLEANSERS';
export const SEARCH_TEXT_SERUMS = 'SEARCH_TEXT_SERUMS';
export const SEARCH_TEXT_SUNSCREEN = 'SEARCH_TEXT_SUNSCREEN';
export const STAR_1 = 'STAR_1';
export const STAR_2 = 'STAR_2';
export const STAR_3 = 'STAR_3';
export const STAR_4 = 'STAR_4';
export const STAR_5 = 'STAR_5';
export const TELL_YOUR_BESTIES_ABOUT = 'TELL_YOUR_BESTIES_ABOUT';
export const SELECT_ALL = 'SELECT_ALL';
export const CHOOSE_YOUR_STORE = 'CHOOSE_YOUR_STORE';
export const STAY_ON_NYKAA = 'STAY ON NYKAA.COM';

// User Authentication & Verification
export const VERIFY_WITH_OTP = 'VERIFY_WITH_OTP';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const YOUR_NEW_PASSWORD = 'YOUR_NEW_PASSWORD';
export const SEND_OTP = 'SEND_OTP';
export const VERIFY = 'VERIFY';
export const CONTINUE = 'CONTINUE';
export const CONFIRM = 'CONFIRM';
export const SIGN_IN = 'SIGN_IN';

// Mobile Verification
export const MOBILE_NUMBER_VERIFIED = 'MOBILE_NUMBER_VERIFIED';
export const VERIFICATION_PENDING = 'VERIFICATION_PENDING';
export const DONT_GO_JUST_YET = 'DONT_GO_JUST_YET';
export const MOBILE_VERIFY_SUCCESS_MESSAGE = 'MOBILE_VERIFY_SUCCESS_MESSAGE';
export const MOBILE_VERIFY_EXHAUSTED_MESSAGE =
  'MOBILE_VERIFY_EXHAUSTED_MESSAGE';
export const MOBILE_VERIFY_CLOSED_MESSAGE = 'MOBILE_VERIFY_CLOSED_MESSAGE';
export const ALMOST_THERE = 'ALMOST_THERE';
export const GETTING_YOU_BACK = 'GETTING_YOU_BACK';
export const PLEASE_LOGIN_AGAIN = 'PLEASE_LOGIN_AGAIN';

// Pro Registration
export const VERIFY_DETAILS = 'VERIFY_DETAILS';
export const ENTER_SHIPPING_ADDRESS = 'ENTER_SHIPPING_ADDRESS';
export const AADHAAR_CARD = 'AADHAAR_CARD';
export const DRIVING_LICENCE = 'DRIVING_LICENCE';
export const PAN_CARD = 'PAN_CARD';
export const OTHER_VALID_GOVT_ID = 'OTHER_VALID_GOVT_ID';

// Search & Suggestions
export const TOP_PRODUCTS = 'TOP_PRODUCTS';
export const SEARCH_FOR = 'SEARCH_FOR';
export const SEARCH = 'SEARCH';
export const SEARCH_SHOWING = 'SEARCH_SHOWING';
export const SEARCH_RESULTS_FOR = 'SEARCH_RESULTS_FOR';
export const SEARCH_NO_RESULTS_FOUND_FOR = 'SEARCH_NO_RESULTS_FOUND_FOR';
export const SEARCH_CHECK_SPELLING = 'SEARCH_CHECK_SPELLING';
export const SEARCH_START_NEW = 'SEARCH_START_NEW';

// Error Messages
export const ERROR_BOUNDARY_TITLE = 'ERROR_BOUNDARY_TITLE';
export const SORRY_PAGE_NOT_FOUND_DETAILED = 'SORRY_PAGE_NOT_FOUND_DETAILED';
export const PAGE_MOVED_OR_DELETED = 'PAGE_MOVED_OR_DELETED';
export const TRY_SEARCHING_OR_HOMEPAGE = 'TRY_SEARCHING_OR_HOMEPAGE';
export const GO_BACK_TO_HOME_PAGE = 'GO_BACK_TO_HOME_PAGE';
export const GO_TO_HOMEPAGE = 'GO_TO_HOMEPAGE';
export const PAGE_STOLEN_TITLE = 'PAGE_STOLEN_TITLE';
export const PAGE_STOLEN_SUBTITLE = 'PAGE_STOLEN_SUBTITLE';

// Stores & Events
export const SEARCH_BY_CITY = 'SEARCH_BY_CITY';
export const SEARCH_BY_BRANDS = 'SEARCH_BY_BRANDS';
export const VIEW_ALL_STORE = 'VIEW_ALL_STORE';
export const ENTER_PINCODE = 'ENTER_PINCODE';
export const SEARCH_BRANDS = 'SEARCH_BRANDS';
export const CHOOSE_STORE = 'CHOOSE_STORE';

// Form Elements
export const VIEW_SIMILAR = 'VIEW_SIMILAR';
export const MORE_VIDEOS = 'MORE_VIDEOS';

// User Portfolio
export const ENTER_DETAILS = 'ENTER_DETAILS';
export const HELP_YOUR_FELLOW_SHOPPERS = 'HELP_YOUR_FELLOW_SHOPPERS';
export const FIND_YOUR_TRIBE = 'FIND_YOUR_TRIBE';

// Reviews
export const REVIEW_TITLE_PLACEHOLDER = 'REVIEW_TITLE_PLACEHOLDER';
export const REVIEW_DESCRIPTION_PLACEHOLDER = 'REVIEW_DESCRIPTION_PLACEHOLDER';

// Error Messages
export const SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG';
export const INVALID_EMAIL_MESSAGE = 'INVALID_EMAIL_MESSAGE';
export const COUPON_COLLECT_ERROR = 'COUPON_COLLECT_ERROR';

// Form Labels
export const MOBILE_NUMBER = 'MOBILE_NUMBER';
export const NEW_PASSWORD_LABEL = 'NEW_PASSWORD_LABEL';
export const RE_ENTER_NEW_PASSWORD_LABEL = 'RE_ENTER_NEW_PASSWORD_LABEL';
export const EMAIL_ADDRESS_LABEL = 'EMAIL_ADDRESS_LABEL';
export const ENTER_OTP_MANUALLY = 'ENTER_OTP_MANUALLY';

// Pro Registration
export const IDENTITY_PROOF_TITLE = 'IDENTITY_PROOF_TITLE';
export const IDENTITY_PROOF_SUBTITLE = 'IDENTITY_PROOF_SUBTITLE';
export const REGISTER_FOR_NYKAA_PRO = 'REGISTER_FOR_NYKAA_PRO';
export const UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS';
export const GST_CERTIFICATE_LABEL = 'GST_CERTIFICATE_LABEL';
export const ENTER_GST_NUMBER = 'ENTER_GST_NUMBER';
export const MY_WEBSITE_LABEL = 'MY_WEBSITE_LABEL';
export const SOCIAL_OR_BUSINESS_PAGE_LABEL = 'SOCIAL_OR_BUSINESS_PAGE_LABEL';
export const TRAINING_CERTIFICATE_LABEL = 'TRAINING_CERTIFICATE_LABEL';
export const VISITING_CARD_LABEL = 'VISITING_CARD_LABEL';
export const SALARY_SLIP_LABEL = 'SALARY_SLIP_LABEL';
export const NO_PROOF_LABEL = 'NO_PROOF_LABEL';
export const NAME_AS_APPEARS_ON_DOCUMENT = 'NAME_AS_APPEARS_ON_DOCUMENT';
export const NAME_AS_APPEARS_ON_CERTIFICATE = 'NAME_AS_APPEARS_ON_CERTIFICATE';
export const NAME_AS_APPEARS_ON_CARD = 'NAME_AS_APPEARS_ON_CARD';
export const ENTER_VALID_GOVT_ID = 'ENTER_VALID_GOVT_ID';

// Video Consultation
export const VIDEO_CONSULTATION_WAITING = 'VIDEO_CONSULTATION_WAITING';
export const VIDEO_CONSULTATION_BUSY = 'VIDEO_CONSULTATION_BUSY';
export const VIDEO_CONSULTATION_WHATSAPP = 'VIDEO_CONSULTATION_WHATSAPP';
export const VIDEO_CONSULTATION_UPCOMING = 'VIDEO_CONSULTATION_UPCOMING';
export const VIDEO_CONSULTATION_CONNECT = 'VIDEO_CONSULTATION_CONNECT';
export const SCHEDULE_VIDEO_CALL = 'SCHEDULE_VIDEO_CALL';
export const RESCHEDULE_VIDEO_CALL = 'RESCHEDULE_VIDEO_CALL';
export const CONNECT_WITH_ADVISOR = 'CONNECT_WITH_ADVISOR';
export const TAP_TO_PROCEED = 'TAP_TO_PROCEED';
export const AGREE_TNC = 'AGREE_TNC';

// Stores & Events
export const TRY_DIFFERENT_PINCODE = 'TRY_DIFFERENT_PINCODE';
export const VISIT_CLOSEST_STORE = 'VISIT_CLOSEST_STORE';
export const TRY_CHANGING_CITY = 'TRY_CHANGING_CITY';
export const CURRENTLY_CLOSED = 'CURRENTLY_CLOSED';
export const SEARCH_STORES_BY_BRANDS = 'SEARCH_STORES_BY_BRANDS';
export const BRAND_NOT_AVAILABLE = 'BRAND_NOT_AVAILABLE';

// Product Pages (VIEW_SIMILAR and GOT_IT already exist in lang.data.json - use existing)
export const SHARE_AND_EARN_OFFER = 'SHARE_AND_EARN_OFFER';
export const HOW_TO = 'HOW_TO';

// Loyalty / Prive
export const FAQS_TITLE = 'FAQS_TITLE';
export const HOW_IT_WORKS_TITLE = 'HOW_IT_WORKS_TITLE';
export const SHOP_TITLE = 'SHOP_TITLE';
export const REVIEW_AND_RATE_TITLE = 'REVIEW_AND_RATE_TITLE';
export const POINT_MULTIPLIERS_TITLE = 'POINT_MULTIPLIERS_TITLE';
export const EARN_POINTS_SUMMARY = 'EARN_POINTS_SUMMARY';
export const BONUS_POINTS_SUMMARY = 'BONUS_POINTS_SUMMARY';

// Search (TRENDING_SEARCHES already exists in lang.data.json - use existing)
export const RECENT_SEARCHES = 'RECENT_SEARCHES';

// Coupon Offers
export const COUPONS_AND_OFFERS = 'COUPONS_AND_OFFERS';
export const DISCOVER_NYKAA_COUPONS = 'DISCOVER_NYKAA_COUPONS';
export const GET_EXTRA_OFF = 'GET_EXTRA_OFF';

// Sign Up / Auth
export const OR_SIGN_IN_USING = 'OR_SIGN_IN_USING';
export const SIGN_IN_WITH_MOBILE_EMAIL = 'SIGN_IN_WITH_MOBILE_EMAIL';
export const MOBILE_EMAIL_LABEL = 'MOBILE_EMAIL_LABEL';
export const CONTINUE_WITH_MOBILE_NUMBER = 'CONTINUE_WITH_MOBILE_NUMBER';

// Account Merging
export const GET_HELP_FROM_SUPPORT = 'GET_HELP_FROM_SUPPORT';

// Pro Intro / FAQ
export const FREQUENTLY_ASKED_QUESTIONS = 'FREQUENTLY_ASKED_QUESTIONS';
export const CHECK_YOUR_QUALIFICATION = 'CHECK_YOUR_QUALIFICATION';

// Collapsible PDP Config
export const COLLAPSE_PD_CONFIG_OFFER_SECTION_TITLE =
  'COLLAPSE_PD_CONFIG_OFFER_SECTION_TITLE';
export const COLLAPSE_PD_CONFIG_COMBO_SECTION_TITLE =
  'COLLAPSE_PD_CONFIG_COMBO_SECTION_TITLE';
export const BEST_PRICE_SUBTITLE = 'BEST_PRICE_SUBTITLE';

// Footer (SEND already exists in lang.data.json - use existing)

// Product Page - Seller Info
export const SOLD_BY = 'SOLD_BY';

// Search
export const POPULAR_PRODUCTS = 'POPULAR_PRODUCTS';

// Product Page - Additional
export const FILTER_BY_PRODUCT = 'FILTER_BY_PRODUCT';
export const EXPIRY_DATE = 'EXPIRY_DATE';
export const RETURN_POLICY = 'RETURN_POLICY';
export const MOST_USEFUL_REVIEW_TITLE = 'MOST_USEFUL_REVIEW_TITLE';
export const REFINE_REVIEWS_BY = 'REFINE_REVIEWS_BY';
export const NOW_PLAYING = 'NOW_PLAYING';
export const VIEW_MORE_PRODUCTS = 'VIEW_MORE_PRODUCTS';
export const DISMISS = 'DISMISS';

// Footer
export const RELATED_CATEGORIES = 'RELATED_CATEGORIES';
export const POPULAR_LINKS = 'POPULAR_LINKS';
export const FILTERS_APPLIED = 'FILTERS_APPLIED';

// User Auth & Verification
export const VERIFY_YOUR_MOBILE_NUMBER = 'VERIFY_YOUR_MOBILE_NUMBER';
export const GET_ALL_UPDATES_ON_ORDERS = 'GET_ALL_UPDATES_ON_ORDERS';
export const ENTER_OTP_RECEIVED_ON = 'ENTER_OTP_RECEIVED_ON';
export const KINDLY_ENTER_MOBILE_NUMBER = 'KINDLY_ENTER_MOBILE_NUMBER';
export const DONE = 'DONE';
export const MERGING_ACCOUNT_CHANGE = 'MERGING_ACCOUNT_CHANGE';
export const PLEASE_VERIFY_ACCOUNT = 'PLEASE_VERIFY_ACCOUNT';
export const AUTO_READING_OTP = 'AUTO_READING_OTP';
export const WE_HAVE_SENT_OTP_TO = 'WE_HAVE_SENT_OTP_TO';
export const TAKING_TOO_LONG = 'TAKING_TOO_LONG';
export const ENTER_6_DIGIT_OTP = 'ENTER_6_DIGIT_OTP';
export const ENTER_OTP_SENT_TO = 'ENTER_OTP_SENT_TO';
export const PHONE_NUMBER_VERIFIED = 'PHONE_NUMBER_VERIFIED';
export const LOGIN_CREATE_ACCOUNT = 'LOGIN_CREATE_ACCOUNT';
export const OTP_VERIFICATION = 'OTP_VERIFICATION';
export const GET_OTP = 'GET_OTP';
export const AUTH_SUBTITLE_EMAIL_VERIFICATION = 'AUTH_SUBTITLE_EMAIL_VERIFICATION';
export const EMAIL_ADDRESS = 'EMAIL_ADDRESS';
export const RESEND_OTP = 'RESEND_OTP';
export const PROTECT_YOUR_ACCOUNT = 'PROTECT_YOUR_ACCOUNT';
export const IN = 'IN';

// Loyalty & Rewards
export const YOUR_REWARD_POINTS_HISTORY = 'YOUR_REWARD_POINTS_HISTORY';
export const PRIVE_COUPONS_FOR_YOU = 'PRIVE_COUPONS_FOR_YOU';

// User Portfolio
export const BE_PART_OF_TRUSTED_COMMUNITY = 'BE_PART_OF_TRUSTED_COMMUNITY';

// Stores
export const NOW_YOU_CAN_VISIT_STORE = 'NOW_YOU_CAN_VISIT_STORE';

// Pro Registration
export const PRE_REGISTRATION_FAQS = 'PRE_REGISTRATION_FAQS';
export const POST_REGISTRATION_FAQS = 'POST_REGISTRATION_FAQS';

// Language Selector
export const SELECT_YOUR_LANGUAGE = 'SELECT_YOUR_LANGUAGE';

// Success/Error Messages
export const WOOHOO = 'WOOHOO';

export const SIMILAR_PRODUCTS_TEXT = 'Similar Products';
export const SIMILAR_PRODUCTS_NBSKU = 'Similar products';
export const RECENTLY_VIEWED = 'RECENTLY_VIEWED';

// New constants for hardcoded strings migration (only add if not already exists)
export const RE_ENTER_NEW_PASSWORD = 'RE_ENTER_NEW_PASSWORD';
export const MOBILE_NUMBER_PLACEHOLDER = 'MOBILE_NUMBER_PLACEHOLDER';
export const CONNECTION_LOST = 'CONNECTION_LOST';
export const NO_INTERNET_CONNECTION = 'NO_INTERNET_CONNECTION';
export const BACK_ONLINE = 'BACK_ONLINE';
export const INTERNET_CONNECTION_PROBLEM = 'INTERNET_CONNECTION_PROBLEM';
export const OFFER_AVAILABLE = 'OFFER_AVAILABLE';
export const CHOOSE_LANGUAGE = 'CHOOSE_LANGUAGE';
export const MY_DETAILS = 'MY_DETAILS';
export const CALL_NOW = 'CALL_NOW';
export const SCHEDULE_CALL = 'SCHEDULE_CALL';
export const CALL_SCHEDULED = 'CALL_SCHEDULED';
export const CANCEL_CALL = 'CANCEL_CALL';
export const NOT_AVAILABLE = 'NOT_AVAILABLE';
export const AVAILABLE = 'AVAILABLE';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const YOUR_WISHLIST = 'YOUR_WISHLIST';
export const TOP_BRANDS = 'TOP_BRANDS';
export const LOADING = 'LOADING';
export const VISIT_NEAREST_STORE = 'VISIT_NEAREST_STORE';
export const SHOW_TERMS_AND_CONDITIONS = 'SHOW_TERMS_AND_CONDITIONS';
export const FAQS = 'FAQS';
export const VIEW_MORE_FAQS = 'VIEW_MORE_FAQS';
export const HOW_IT_WORKS = 'HOW_IT_WORKS';
export const SHOP = 'SHOP';
export const REVIEW_AND_RATE = 'REVIEW_AND_RATE';
export const POINT_MULTIPLIERS = 'POINT_MULTIPLIERS';
export const SHOP_NOW = 'SHOP_NOW';
export const UPDATE_YOUR_BIRTHDAY = 'UPDATE_YOUR_BIRTHDAY';
export const WILL_UNLOCK_IN = 'WILL_UNLOCK_IN';
export const RECENTLY_VIEWED_WIDGET = 'recently_viewed';

// Reusing existing keys from lang.data.json
export const SHADES = 'SHADES';
export const CUSTOMERS_ALSO_VIEWED = 'CUSTOMERS_ALSO_VIEWED';
export const CUSTOMERS_ALSO_BOUGHT = 'CUSTOMERS_ALSO_BOUGHT';

// New user-facing string keys
export const NOTIFY = 'NOTIFY';
export const RECO_MORE_FROM_BRAND = 'RECO_MORE_FROM_BRAND';
export const RECO_MORE_FROM_CATEGORY = 'RECO_MORE_FROM_CATEGORY';
export const NUDGE_TITLE_TEXT = 'NUDGE_TITLE_TEXT';
export const NUDGE_TITLE_TEXT_1 = 'NUDGE_TITLE_TEXT_1';

export const ONLY_A_FEW_LEFT = 'ONLY_A_FEW_LEFT';
export const SOLD_OUT_EXCLAIMATION = 'SOLD_OUT_EXCLAIMATION';
export const COLLECT_OFFERS = 'COLLECT_OFFERS';
export const HOW_TO_COLLECT_COUPONS = 'HOW_TO_COLLECT_COUPONS';
export const SKIP_NOW = 'SKIP_NOW';
export const FROM = 'FROM';
export const TO = 'TO';
export const AUTO_APPLIED = 'AUTO_APPLIED';
export const KNOW_HOW = 'KNOW_HOW';
export const COUPON_SUBTITLE = 'COUPON_SUBTITLE';
export const WITH_OFFERS = 'WITH_OFFERS';
export const SKIP = 'SKIP';
export const CANCEL = 'CANCEL';
export const COLLECT_COUPONS = 'COLLECT_COUPONS';
export const EASY_RETURN_POLICY = 'EASY_RETURN_POLICY';
export const VIEW_ALL = 'VIEW_ALL';
export const OFFERS = 'OFFERS';
export const OFFER_PREFIX = 'OFFER_PREFIX';
export const SHARE_FAILED = 'SHARE_FAILED';
export const SHARED_SUCCESS = 'SHARED_SUCCESS';
export const GAME_RULES = 'GAME_RULES';
export const SEE_PREVIOUS_PREDICTIONS = 'SEE_PREVIOUS_PREDICTIONS';
export const UPCOMING_MATCHES = 'UPCOMING_MATCHES';
export const ACHIVEMENTS = 'ACHIVEMENTS';
export const PAST_PREDICTION = 'PAST_PREDICTION';
export const PREDICT_AND_WIN = 'PREDICT_AND_WIN';
export const NO_MATCHES_MSG = 'NO_MATCHES_MSG';
export const CONTINUE_SHOPPING = 'CONTINUE_SHOPPING';
export const GET_EXCITING_COUPONS = 'GET_EXCITING_COUPONS';
export const LEARN_MORE = 'LEARN_MORE';
export const YOU_WON_COUPON = 'YOU_WON_COUPON';
export const VIEW_COUPONS = 'VIEW_COUPONS';
export const AND = 'AND';
export const VIEW_CERTIFICATE = 'VIEW_CERTIFICATE';
export const VIEW_POLICY = 'VIEW_POLICY';
export const SELECTED = 'SELECTED';

// Account Management
export const MY_ACCOUNT = 'MY_PROFILE';
export const MY_ADDRESSES = 'MY_ADDRESSES';
export const MY_HELP_CENTER = 'MY_HELP_CENTER';
export const MY_LOYALTY_PROGRAM = 'MY_LOYALTY_PROGRAM';
export const MY_COUPONS = 'MY_COUPONS';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const MY_SAVED_PAYMENTS = 'MY_SAVED_PAYMENTS';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const EDIT_PROFILE = 'EDIT_PROFILE';

// Address Management
export const SAVED_ADDRESSES_TAB = 'SAVED_ADDRESSES_TAB';
export const NEW_ADDRESSES = 'NEW_ADDRESSES';
export const SELECT_SHIPPING_COUNTRY = 'SELECT_SHIPPING_COUNTRY';
export const NO_ADDRESSES_FOUND = 'NO_ADDRESSES_FOUND';
export const SELECT_COUNTRY = 'SELECT_COUNTRY';
export const NAME_LABEL_SIMPLE = 'NAME_LABEL_SIMPLE';
